import axios from 'axios';
import { appConfig } from '../../Config/app';

const authAPI = axios.create({
  baseURL: appConfig.API_BASE_URL,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
});

function apiSignupRequest(action) {
  return authAPI.post(`/api/v1/signup/`, action.data, null);
}

function apiChangePasswordRequest(action) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Token ${action.token}`,
  };
  return authAPI.post(`/api/v1/change-password/`, action.data, {
    headers,
  });
}

function apiUserConfirmationRequest(action) {
  return authAPI.post(`/api/v1/user/confirm/`, {
    confirmation_token: action.confirmationCode,
  });
}

function apiResendConfirmationRequest(action) {
  return authAPI.post(`/api/v1/user/resend-confirmation/`, {
    email: action.email,
  });
}

function apiSetPasswordRequest(action) {
  return authAPI.post(`/api/v1/user/set-password/`, null, {
    headers: { Authorization: `Token ${action.token}` },
  });
}

export const signupServices = {
  apiSignupRequest,
  apiChangePasswordRequest,
  apiUserConfirmationRequest,
  apiResendConfirmationRequest,
  apiSetPasswordRequest,
};
